const getCustomQuoteDetailsModuleAssetUrl = () => {
	return new Worker(new URL("../../workers/customQuoteConfirmationPDF.worker.tsx", import.meta.url), {
		type: "module"
	});
};

export default getCustomQuoteDetailsModuleAssetUrl;
